"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
exports.StyledEarningsCalculator = styled_1.default.div `
width: 750px;
color: ${theme_1.default.colours.text.default};

.calc__wrap {
	background-color: ${theme_1.default.colours.delimiter.default};
	padding: ${theme_1.default.spacing.large};
	padding-top: ${theme_1.default.spacing.small};
	border-radius: ${theme_1.default.layout.radius.default};
	color: ${theme_1.default.colours.text.dark};
}


#night-price {
	width: 90px;
	text-align: right;
}

.calc__row {
	width: 710px;
	height: calc(2.8125rem + 1px);
	line-height: 2.8125rem;
	border-top: 1px solid ${theme_1.default.colours.text.medium};
}

.calc__row-label {
	line-height: 2.8125rem;
	max-width: 600px;
	float: left;
	vertical-align: middle;
}

.calc__row-value {
	line-height: 2.8125rem;
	nim-width: 80px;
	float: right;
	vertical-align: middle;
	text-align: right;
}

.calc__label {}

.calc__final {
	border-color: ${theme_1.default.colours.text.default};
}
`;
//# sourceMappingURL=earnings-calculator.styled.js.map